import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ApiServiceService } from './api-service.service';
import { Injectable } from '@angular/core';

export interface ConfiguracionResponse {
  k?: string;
  endpoint_respaldo?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private KEY_K = "k";
  private KEY_ENDPOINT_RESPALDO = "endpoint_respaldo";
  private KEY_ALARM_MODE = "alarm_mode";
  private KEY_FIREFIGHTERS_SELECTION = "firefighters_selection";
  private KEY_ENABLED_LEVELS = "enabled_levels";

  constructor(private apiService: ApiServiceService) { }

  getConfigDispatcherBackup(): Observable<any> {
    return this.apiService.get<ConfiguracionResponse>('/api/configuracion/convocatoria-respaldo/').pipe(map((configJson: ConfiguracionResponse) => {
      
      window.localStorage.setItem(this.KEY_K, configJson.k);
      window.localStorage.setItem(this.KEY_ENDPOINT_RESPALDO, configJson.endpoint_respaldo);

      return configJson;
    }));
  }

  getKeyDispatchBackup() {
    return window.localStorage.getItem(this.KEY_K);
  }

  getEndpointBackup() {
    return window.localStorage.getItem(this.KEY_ENDPOINT_RESPALDO);
  }

  cleanConfig() {
    window.localStorage.removeItem(this.KEY_K);
    window.localStorage.removeItem(this.KEY_ENDPOINT_RESPALDO);
  }

  setAlarmMode(mode: string) {
    window.localStorage.setItem(this.KEY_ALARM_MODE, mode);
  }

  getAlarmMode(){
    return window.localStorage.getItem(this.KEY_ALARM_MODE);
  }

  setFirefightersSelection(enabled: boolean){
    window.localStorage.setItem(this.KEY_FIREFIGHTERS_SELECTION, enabled ? "1" : "0");
  }

  getFirefightersSelection(): boolean {
    return window.localStorage.getItem(this.KEY_FIREFIGHTERS_SELECTION) == "1";
  }

  setEnabledLevels(enabled: boolean) {
    window.localStorage.setItem(this.KEY_ENABLED_LEVELS, enabled ? "1" : "0");
  }

  getEnabledLevels(): boolean {
    return window.localStorage.getItem(this.KEY_ENABLED_LEVELS) == "1";
  }
}
